import styled from "styled-components";

export default styled("div")<{padding: string, display?: string}>`
    padding: ${props => props.padding};
    ${props => props.display && `display: ${props.display}`};
`;